import { getFieldValidator } from "../config/fieldValidators";
import { FieldErrors } from "./collectFieldErrors";

/**
 * The browser's errors plus each named validator's, in the form's field order so the
 * first message is the first field to fix. A field the browser already faults keeps
 * that message - "is required" comes before "must be a number".
 */
export function mergeRuleErrors(
  browserErrors: FieldErrors,
  record: Record<string, unknown> | null,
  validatorKeys: Record<string, string>,
  fieldOrder: string[]
): FieldErrors {
  const ruleErrors: FieldErrors = {};

  Object.entries(validatorKeys).forEach(([name, key]) => {
    const validator = getFieldValidator(key);
    const message = validator ? validator(record?.[name], record ?? {}) : "";

    if (message) {
      ruleErrors[name] = message;
    }
  });

  const names = [
    ...fieldOrder,
    ...Object.keys(browserErrors).filter((name) => !fieldOrder.includes(name)),
  ];
  const merged: FieldErrors = {};

  names.forEach((name) => {
    const message = browserErrors[name] ?? ruleErrors[name];

    if (message) {
      merged[name] = message;
    }
  });

  return merged;
}
